export const BLOCK_TYPE_FIELD_OF_AREA_LIST_ALL = 'fieldOfAreaListAll';
